<template>
  <button>{{ title }}</button>
</template>

<script>
export default {
  name: 'ButtonSubmit',
  props: {
    title: String,
  },
}
</script>

<style scoped>
button {
  border-radius: 4px;
  background-color: #188dff;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  text-align: center;
  color: #ffffff;
}
button:disabled {
  background-color: #c3c3c3;
  cursor: auto;
}
</style>
